import MyUtil from './MyUtil';

const ConvertDirectDiscount = {
  handleNew: (data) => {
    let directDiscount = {
      id: data.id,
      discount_value: MyUtil.convertMoney(data.discount_value),
      max_value: MyUtil.convertMoney(data.max_value),
      city_id: data.city_id,
      vhc_id: data.vhc_id,
      vhc_part_id: data.vhc_part_id,
      part_id: data.part_id,
      active_at: data.active_at,
      expire_at: data.expire_at,
      is_active: data.is_active,
    };

    directDiscount = MyUtil.clean(directDiscount);
    return directDiscount;
  },
  handleCheck: (state) => {
    const { discount_value, active_at, expire_at } = state;
    const message = [];
    console.log(
      'check ',
      ' - ',
      discount_value,
      ' - ',
      active_at,
      ' - ',
      expire_at
    );
    if (!discount_value) message.push('giá trị giảm');
    if (!active_at) message.push('thời gian bắt đầu');
    if (!expire_at) message.push('thời gian kết thúc');
    return message.length > 0 ? message : false;
  },
};

export default ConvertDirectDiscount;
